export default "__VITE_ASSET__277b04d1__"